import { render, staticRenderFns } from "./MediacontactAdd.vue?vue&type=template&id=48ab9df1"
import script from "./MediacontactAdd.vue?vue&type=script&lang=js"
export * from "./MediacontactAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports